import { EnvConfig } from "../models/env-config";
import { WindowWithCommonEnv } from "../models/window-with-common-env";

declare const window: WindowWithCommonEnv;

export const environment: EnvConfig = {
  production: window.commonEnv?.production ?? false,
  envName: window.commonEnv?.envName ?? "local",

  // intern app urls
  emsAuthServiceUrl: window.commonEnv?.emsAuthServiceUrl ?? "http://localhost:8700/gast-ems-auth/",
  dashboardUrl: window.commonEnv?.dashboardUrl ?? "http://localhost:8701/gast-ems-dashboard/",
  hkvUrl: window.commonEnv?.hkvUrl ?? "http://localhost:8702/gast-ems-honorarkraft/",
  itembankUrl: window.commonEnv?.itembankUrl ?? "http://localhost:8703/gast-ems-itembank/",
  authortoolUrl: window.commonEnv?.authortoolUrl ?? "http://localhost:8704/gast-ems-authortool/",
  iamUrl: window.commonEnv?.iamUrl ?? "http://localhost:8705/gast-ems-iam/",
  mediaUrl: window.commonEnv?.mediaUrl ?? "http://localhost:8706/gast-ems-media/",
  licenceEmsUrl: window.commonEnv?.licenceEmsUrl ?? "http://localhost:8708/gast-ems-licence/",
  courseUrl: window.commonEnv?.courseUrl ?? "http://localhost:8709/gast-ems-course/",
  onscreenGradingPortalUrl:
    window.commonEnv?.onscreenGradingPortalUrl ?? "http://localhost:8710/gast-portal-onscreen-grading/",
  participantEmsUrl: window.commonEnv?.participantEmsUrl ?? "http://localhost:8716/gast-ems-participants/",
  eventEmsUrl: window.commonEnv?.eventEmsUrl ?? "http://localhost:8718/gast-ems-event/",
  organizationEmsUrl: window.commonEnv?.organizationEmsUrl ?? "http://localhost:8719/gast-ems-organization/",
  esaEmsUrl: window.commonEnv?.esaEmsUrl ?? "http://localhost:8720/gast-ems-esa/",
  authortoolNGUrl: window.commonEnv?.authortoolNGUrl ?? "http://localhost:8721/gast-ems-authortool-ng/",
  personUrl: window.commonEnv?.personUrl ?? "http://localhost:8722/gast-ems-person/",
  claimUrl: window.commonEnv?.claimUrl ?? "http://localhost:8727/gast-ems-claim/",
  financeUrl: window.commonEnv?.financeUrl ?? "http://localhost:8728/gast-ems-finance/",
  materialUrl: window.commonEnv?.materialUrl ?? "http://localhost:8729/gast-ems-material/",
  materialControlEmsUrl: window.commonEnv?.materialControlEmsUrl ?? "http://localhost:8731/gast-ems-material-control/",

  // intern webservices ( for external calls add /api )
  hkvServiceUrl: window.commonEnv?.hkvServiceUrl ?? "http://localhost:8801/gast-service-honorarkraft/",
  itembankServiceUrl: window.commonEnv?.itembankServiceUrl ?? "http://localhost:8800/gast-service-itembank/",
  authorServiceUrl: window.commonEnv?.authorServiceUrl ?? "http://localhost:8800/gast-service-itembank/api/",
  iamServiceUrl: window.commonEnv?.iamServiceUrl ?? "http://localhost:8802/gast-service-iam/",
  classicServiceUrl: window.commonEnv?.classicServiceUrl ?? "http://localhost:8803/gast-service-classic/",
  mediaServiceUrl: window.commonEnv?.mediaServiceUrl ?? "http://localhost:8806/gast-service-media/",
  courseServiceUrl: window.commonEnv?.courseServiceUrl ?? "http://localhost:8807/gast-service-course/",
  licenceServiceUrl: window.commonEnv?.licenceServiceUrl ?? "http://localhost:8808/gast-service-licence/",
  coreServiceUrl: window.commonEnv?.coreServiceUrl ?? "http://localhost:8810/gast-service-core/",
  onscreenGradingServiceUrl:
    window.commonEnv?.onscreenGradingServiceUrl ?? "http://localhost:8812/gast-service-onscreen-grading/",
  bookingServiceUrl: window.commonEnv?.bookingServiceUrl ?? "http://localhost:8811/gast-service-booking/",
  hcoServiceUrl: window.commonEnv?.hcoServiceUrl ?? "http://localhost:8044/gast-service-hco/",
  onsetServiceUrl: window.commonEnv?.onsetServiceUrl ?? "http://localhost:8008/gast-service-onset/",
  authServiceUrl: window.commonEnv?.authServiceUrl ?? "http://localhost:8053/gast-service-auth/",
  queryServiceUrl: window.commonEnv?.queryServiceUrl ?? "http://localhost:8056/gast-service-query/",
  eventServiceUrl: window.commonEnv?.eventServiceUrl ?? "http://localhost:8057/gast-service-event/",
  organizationServiceUrl:
    window.commonEnv?.organizationServiceUrl ?? "http://localhost:8058/gast-service-organization/",
  esaServiceUrl: window.commonEnv?.esaServiceUrl ?? "http://localhost:8060/gast-service-esa/",
  financeServiceUrl: window.commonEnv?.financeServiceUrl ?? "http://localhost:8061/gast-service-finance/",
  certificateServiceUrl: window.commonEnv?.certificateServiceUrl ?? "http://localhost:8064/gast-service-certificate/",
  lmsServiceUrl: window.commonEnv?.lmsServiceUrl ?? "http://localhost:8077/gast-service-lms/",
  materialServiceUrl: window.commonEnv?.materialServiceUrl ?? "http://localhost:8078/gast-service-material/",
  dtzAuthServiceUrl: window.commonEnv?.dtzAuthServiceUrl ?? "http://localhost:8053/gast-service-auth/",
  dtzEventServiceUrl: window.commonEnv?.dtzEventServiceUrl ?? "http://localhost:8057/gast-service-event/",
  dtzCoreServiceUrl: window.commonEnv?.dtzCoreServiceUrl ?? "http://localhost:8810/gast-service-core/",
  uiServiceUrl: window.commonEnv?.uiServiceUrl ?? "http://localhost:8090/gast-service-ui/",
  materialControlServiceUrl:
    window.commonEnv?.materialControlServiceUrl ?? "http://localhost:8091/gast-service-material-control/",
  tscServiceUrl: window.commonEnv?.tscServiceUrl ?? "http://localhost:8059/gast-service-tsc/",
  examDeliveryControllerUrl:
    window.commonEnv?.examDeliveryControllerUrl ?? "http://localhost:8787/gast-service-exam-delivery-controller/",
  evaluationServiceUrl: window.commonEnv?.evaluationServiceUrl ?? "http://localhost:9007/gast-service-evaluation/",

  // extern web services
  itembankPublicServiceUrl:
    window.commonEnv?.itembankPublicServiceUrl ?? "http://localhost:8809/gast-service-itembank/api/",

  // gast extern app urls
  accountPortalUrl: window.commonEnv?.accountPortalUrl ?? "http://localhost:8715/gast-portal-account/",
  licencePortalUrl: window.commonEnv?.licencePortalUrl ?? "http://localhost:8708/gast-portal-licence/",
  authorPortalUrl: window.commonEnv?.authorPortalUrl ?? "http://localhost:8711/gast-portal-author/",
  hkvPortalUrl: window.commonEnv?.hkvPortalUrl ?? "http://localhost:8751/gast-portal-honorarkraft/",
  portalAuthServiceUrl: window.commonEnv?.portalAuthServiceUrl ?? "http://localhost:8750/gast-portal-auth/",
  registrationPortalUrl: window.commonEnv?.registrationPortalUrl ?? "http://localhost:8717/gast-portal-registration/",
  registrationTestAsPortalUrl:
    window.commonEnv?.registrationTestAsPortalUrl ?? "http://localhost:8717/gast-portal-registration/",
  dashboardPortalUrl: window.commonEnv?.dashboardPortalUrl ?? "http://localhost:8718/gast-portal-dashboard/",
  testcenterPortalUrl: window.commonEnv?.testcenterPortalUrl ?? "http://localhost:8723/gast-portal-testcenter/",
  centerSearchPortalUrl: window.commonEnv?.centerSearchPortalUrl ?? "http://localhost:8724/gast-portal-center-search/",
  participantPortalUrl: window.commonEnv?.participantPortalUrl ?? "http://localhost:8725/gast-portal-participant/",
  certificatePortalUrl: window.commonEnv?.certificatePortalUrl ?? "http://localhost:8726/gast-portal-certificate/",
  duoLMSPortalUrl: window.commonEnv?.duoLMSPortalUrl ?? "http://localhost:8727/duo-portal-lms/",
  dtzPortalUrl: window.commonEnv?.dtzPortalUrl ?? "http://localhost:8717/gast-portal-registration/",
  examinerUrl: window.commonEnv?.examinerUrl ?? "http://localhost:8730/gast-portal-examiner/",
  onsetPortalExamUrl: window.commonEnv?.onsetPortalExamUrl ?? "http://localhost:8716/onset-portal-exam/",

  neeaPortalRegistrationUrl:
    window.commonEnv?.neeaPortalRegistrationUrl ?? "http://localhost:8732/neea-portal-registration/",

  // duo extern app urls
  duoWebshopUrl: window.commonEnv?.duoWebshopUrl ?? "http://localhost:8713/duo-portal-webshop/",
  duoLearnerPortalUrl: window.commonEnv?.duoLearnerPortalUrl ?? "http://localhost:8712/duo-portal-learner/",
  duoOrgaPortalUrl: window.commonEnv?.duoOrgaPortalUrl ?? "http://localhost:8714/duo-portal-organization/",
  duoConnectDRedirectUrl:
    window.commonEnv?.duoConnectDRedirectUrl ??
    "http://localhost:8715/gast-portal-account/login?product-id=4&redirect=http%3A%2F%2Flocalhost%3A8080%2Fc%2Fportal%2Flogin%2Fsso",
  duoPortalTutorUrl: window.commonEnv?.duoPortalTutorUrl ?? "http://localhost:9001/duo-portal-tutor/",

  // google recaptcha
  googleRecaptchaKeySite: window.commonEnv?.googleRecaptchaKeySite ?? "6LdRpbMUAAAAAKovp7j-LrpY1ptZ8dc7-cf1hQ8W",
};
